import { autoCompleteStyles, inputCustomStyles } from "../../styles"
import { useHistory } from "react-router-dom"
import { useI18n } from "providers/I18n"
import { Dispatch, SetStateAction, useMemo, useState } from "react"
import AutoCompleteInput from "../SharedComponents/AutoComplete"
import { AutoCompleteOptionType } from "../../types"
import { debounce } from "lodash/fp"
import { useRevenueParams } from "../../hooks/useRevenueParams"
import { cx } from "@emotion/css"

type Props = {
  brands?: string[]
  brand?: string
  pathname: string
  search: string
  regionDefault: string
  marketDefault: string
  isViewGcf?: boolean
  setIsGcf: Dispatch<SetStateAction<boolean>>
  showDetails: boolean
  disabled: boolean
}
const defaultValues = {
  name: "All",
  code: "All",
}
export function FilterBrand(props: Props) {
  const { t } = useI18n()
  const history = useHistory()
  const {
    brands,
    brand,
    pathname,
    search,
    isViewGcf,
    setIsGcf,
    showDetails,
    disabled,
  } = props
  const [brandInput, setBrandInput] = useState<string | undefined>("All")

  const { brandParam } = useRevenueParams()
  const finaloptions = brands?.filter((b) => b !== "GCF")

  const options =
    finaloptions?.map((brand: string) => ({
      name: brand,
      code: t(`revenue.brand.${brand}`),
    })) || []

  const value = useMemo(() => {
    if (brand) {
      return { name: brand, code: brand }
    }
    if (!brandParam) {
      return defaultValues
    }
    return { name: brandParam, code: brandParam }
  }, [brand, brandParam])

  const onInputChange = (value: string) => {
    setBrandInput(value)
  }
  const onChange = (brand: AutoCompleteOptionType | null) => {
    setBrandInput(brand?.code)
    const updatedUrl = new URLSearchParams(search)
    if (brand?.code !== "GCF" && !showDetails) {
      setIsGcf(false)
    }
    updatedUrl.set("brand", "All")
    !!brand?.code && updatedUrl.set("brand", brand.code)
    history.push({ pathname, search: updatedUrl.toString() })
  }

  return (
    <AutoCompleteInput<AutoCompleteOptionType>
      id="brand"
      name="brand"
      label={t("revenue.filter.brand")}
      blurOnChange={true}
      autoComplete="off"
      onInputChange={debounce(300, onInputChange)}
      value={
        isViewGcf && brandParam === "GCF" && !showDetails
          ? { name: "GCF", code: "GCF" }
          : value
      }
      options={options}
      disabled={disabled}
      renderOption={(option) => <span>{option?.name}</span>}
      onChange={onChange}
      getOptionLabel={(option) => option?.name}
      getOptionSelected={(opt, val) => opt === val}
      classes={{
        paper: autoCompleteStyles.paper,
        inputRoot: cx(
          brandInput !== "All"
            ? inputCustomStyles.blue
            : inputCustomStyles.grey,
          inputCustomStyles.inputRoot,
        ),
        root: autoCompleteStyles.root,
        loading: autoCompleteStyles.loading,
        noOptions: autoCompleteStyles.noOptions,
      }}
    />
  )
}
